<hau-form [formGroup]="filterForm()">
  <div class="filter-group">
    @if(currentTenant()?.type === 'Internal'){
      <div class="filter-control-group">
        <hau-form-field label="Externer Tenant">
          <wr-tenant-select [tenantType]="'External'" formControlName="externalTenantId"></wr-tenant-select>
        </hau-form-field>
      </div>
    }
    <div class="filter-control-group">
      <hau-form-field label="Interner Tenant">
        <wr-tenant-select [tenantType]="'Internal'" formControlName="internalTenantId"></wr-tenant-select>
      </hau-form-field>
    </div>
    <div class="filter-control-group">
      <hau-form-field label="TGA Bauplan">
        <wr-tga-type-select [tenantId]="this.filterForm().controls.internalTenantId.value" formControlName="equipment"></wr-tga-type-select>
      </hau-form-field>
    </div>
  </div>
</hau-form>

<wr-list-view [items]="filteredBuildingEquipments()"
              [loading]="loading()"
              [searchText]="searchText()"
              (searchTextChange)="searchTextChange($event)"
              (selectedChange)="openBuildingDialog($event)"
>
  <ng-template wrListItem let-item>
    <div class="equipment-row">
      <div class="equipment-left">
        <nb-user
          [name]="item.name"
          [picture]="getIcon(item)"
          size="large">
        </nb-user>
        <div class="building-info">
          TGA in {{ item.buildingCount }} Gebäuden vorhanden
        </div>
      </div>
      <button nbButton status="info" size="large" [nbTooltip]="'Gebäudeausstattung'"
              (click)="navigateToBuildingEquipments($event, item.equipmentId)">
        <nb-icon pack="fas" icon="box"></nb-icon>
      </button>
    </div>
  </ng-template>
</wr-list-view>
